import { defineMessages } from 'react-intl';

export default defineMessages({
  CLOSE_DIALOG: {
    defaultMessage: 'Fermer',
  },
});
